module.exports = __webpack_public_path__ + "img/icon1.d984f11d.png";